import { TagMap, Transaction } from '../types';
import { normalizeTagKey } from './tagHelpers';

const INVESTMENTS_PARENT_TAG_KEY = normalizeTagKey('Investments');
const investmentTagKeysCache = new WeakMap<TagMap, Set<string>>();

const collectDescendantTagKeys = (tag: TagMap[string] | undefined, collected: Set<string>) => {
  if (!tag) {
    return;
  }

  const tagKey = normalizeTagKey(tag.name);
  if (collected.has(tagKey)) {
    return;
  }

  collected.add(tagKey);
  (tag.children ?? []).forEach((child) => collectDescendantTagKeys(child, collected));
};

const getInvestmentTagKeys = (tagMap: TagMap): Set<string> => {
  const cached = investmentTagKeysCache.get(tagMap);
  if (cached) {
    return cached;
  }

  const investmentTagKeys = new Set<string>();
  const investmentsParentTag = tagMap[INVESTMENTS_PARENT_TAG_KEY];

  collectDescendantTagKeys(investmentsParentTag, investmentTagKeys);
  investmentTagKeysCache.set(tagMap, investmentTagKeys);
  return investmentTagKeys;
};

const isInvestmentTag = (tagName: string | null | undefined, tagMap: TagMap): boolean => {
  if (!tagName) {
    return false;
  }

  const investmentTagKeys = getInvestmentTagKeys(tagMap);
  return investmentTagKeys.has(normalizeTagKey(tagName));
};

export const isInvestmentDebitTransaction = (transaction: Transaction, tagMap: TagMap): boolean => {
  if (transaction.type !== 'DEBIT') {
    return false;
  }

  if (transaction.tag === null || transaction.tag === undefined) {
    return false;
  }

  return isInvestmentTag(transaction.tag, tagMap);
};
